import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { IconUIComponent } from '../icon/icon.component';

@Component({
  selector: 'fr8bot-ui-dialog-small',
  templateUrl: './dialog-small.component.html',
  styleUrl: './dialog-small.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconUIComponent],
})
export class DialogSmallComponent {
  showCloseButton = input(true);
  minContentHeight = input(0);
  maxContentWidth = input(0);
  disableDefaultWidth = input(false);

  closeDialog = output();
}
